function onPopupLoad() {
  const lastShown = localStorage.getItem('popupLastShown');
  const now = Date.now();

  // 24時間（ミリ秒）
  const twentyFourHours = 24 * 60 * 60 * 1000;

  // 表示から24時間以内なら表示しない
  if (lastShown && now - Number(lastShown) < twentyFourHours) return;

  setTimeout(() => {
    const myPopup = document.getElementById('modal_popup');
    if (!myPopup) return;

    myPopup.classList.add('is-show');
    localStorage.setItem('popupLastShown', String(now)); // 現在時刻を保存

    const closePopupElement = document.getElementsByClassName('js-modal-close');
    for (let i = 0; i < closePopupElement.length; i++) {
      closePopup(closePopupElement[i]);
    }

    function closePopup(element) {
      if (!element) return;
      element.addEventListener('click', function () {
        myPopup.classList.remove('is-show');
      });
    }
  }, 3000); // 3秒後に表示
}

window.addEventListener('DOMContentLoaded', onPopupLoad);